// Product page: say why "Add to Cart" didn't add.
// Most BAG CRAP items are one of a kind. When the shopper already has every one in stock in
// their bag, Shopify refuses the add and the button used to do nothing. cart.js does the add;
// this watches its result and, when refused, shows a short message and opens the bag.
(function () {
  var form = document.querySelector(".product-atc form");
  if (!form || typeof window.fetch !== "function") {
    return;
  }

  function flash(text) {
    var button = form.querySelector("button");
    if (!button) {
      return;
    }
    if (!button._feedbackLabel) {
      button._feedbackLabel = button.innerHTML;
    }
    button.innerHTML = text;
    clearTimeout(button._feedbackTimer);
    button._feedbackTimer = setTimeout(function () {
      button.innerHTML = button._feedbackLabel;
      button._feedbackLabel = null;
    }, 2500);
  }

  function openBag() {
    var bag = document.getElementById("side-cart");
    if (typeof getCartContents === "function") {
      getCartContents();
    }
    if (bag) {
      bag.classList.add("active");
    }
  }

  function handleRefusal(data) {
    var text = (data && (data.description || data.message)) || "";
    if (/sold out/i.test(text)) {
      flash("Sold out");
    } else {
      flash("Already in your bag");
      openBag();
    }
  }

  var origFetch = window.fetch;
  window.fetch = function (input, init) {
    var request = origFetch.apply(this, arguments);
    try {
      var url = typeof input === "string" ? input : (input && input.url) || "";
      var isFormAdd = /\/cart\/add(\.js)?(\?|$)/.test(url) && init && typeof FormData !== "undefined" && init.body instanceof FormData;
      if (isFormAdd) {
        request.then(function (response) {
          if (response.status === 422) {
            response.clone().json().then(handleRefusal, function () { handleRefusal(null); });
          }
        }, function () {});
      }
    } catch (error) {
      // never get in the way of an add to bag
    }
    return request;
  };
})();
